/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminDashboardDto } from '../models';
// @ts-ignore
import type { DashboardRegionTypeDto } from '../models';
/**
 * RestAdminDashboardApi - axios parameter creator
 * @export
 */
export const RestAdminDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * All statistics describe the cohort of candidates whose account was created in the period (dates in Europe/Warsaw). The optional region filter narrows the cohort to candidates who study (regionType STUDY) or want an internship (regionType INTERNSHIP) in the region, except for the region maps, which always show every region so that the selected one can be highlighted. Labels of areas, skills and dictionaries follow Accept-Language. 
         * @summary Get aggregated recruitment statistics for the admin dashboard
         * @param {string} adminUserId 
         * @param {string} [from] First day of the period (inclusive); without it the period starts at the first candidate
         * @param {string} [to] Last day of the period (inclusive); without it the period ends today
         * @param {DashboardRegionTypeDto} [regionType] Which region of the candidate the region filter applies to; required together with region
         * @param {string} [region] ISO 3166-2 code of the region (e.g. PL-14), required together with regionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDashboard: async (adminUserId: string, from?: string, to?: string, regionType?: DashboardRegionTypeDto, region?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('getAdminDashboard', 'adminUserId', adminUserId)
            const localVarPath = `/api/admin/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (regionType !== undefined) {
                localVarQueryParameter['regionType'] = regionType;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAdminDashboardApi - functional programming interface
 * @export
 */
export const RestAdminDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAdminDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * All statistics describe the cohort of candidates whose account was created in the period (dates in Europe/Warsaw). The optional region filter narrows the cohort to candidates who study (regionType STUDY) or want an internship (regionType INTERNSHIP) in the region, except for the region maps, which always show every region so that the selected one can be highlighted. Labels of areas, skills and dictionaries follow Accept-Language. 
         * @summary Get aggregated recruitment statistics for the admin dashboard
         * @param {string} adminUserId 
         * @param {string} [from] First day of the period (inclusive); without it the period starts at the first candidate
         * @param {string} [to] Last day of the period (inclusive); without it the period ends today
         * @param {DashboardRegionTypeDto} [regionType] Which region of the candidate the region filter applies to; required together with region
         * @param {string} [region] ISO 3166-2 code of the region (e.g. PL-14), required together with regionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminDashboard(adminUserId: string, from?: string, to?: string, regionType?: DashboardRegionTypeDto, region?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDashboardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminDashboard(adminUserId, from, to, regionType, region, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminDashboardApi.getAdminDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestAdminDashboardApi - factory interface
 * @export
 */
export const RestAdminDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAdminDashboardApiFp(configuration)
    return {
        /**
         * All statistics describe the cohort of candidates whose account was created in the period (dates in Europe/Warsaw). The optional region filter narrows the cohort to candidates who study (regionType STUDY) or want an internship (regionType INTERNSHIP) in the region, except for the region maps, which always show every region so that the selected one can be highlighted. Labels of areas, skills and dictionaries follow Accept-Language. 
         * @summary Get aggregated recruitment statistics for the admin dashboard
         * @param {string} adminUserId 
         * @param {string} [from] First day of the period (inclusive); without it the period starts at the first candidate
         * @param {string} [to] Last day of the period (inclusive); without it the period ends today
         * @param {DashboardRegionTypeDto} [regionType] Which region of the candidate the region filter applies to; required together with region
         * @param {string} [region] ISO 3166-2 code of the region (e.g. PL-14), required together with regionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDashboard(adminUserId: string, from?: string, to?: string, regionType?: DashboardRegionTypeDto, region?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminDashboardDto> {
            return localVarFp.getAdminDashboard(adminUserId, from, to, regionType, region, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestAdminDashboardApi - interface
 * @export
 * @interface RestAdminDashboardApi
 */
export interface RestAdminDashboardApiInterface {
    /**
     * All statistics describe the cohort of candidates whose account was created in the period (dates in Europe/Warsaw). The optional region filter narrows the cohort to candidates who study (regionType STUDY) or want an internship (regionType INTERNSHIP) in the region, except for the region maps, which always show every region so that the selected one can be highlighted. Labels of areas, skills and dictionaries follow Accept-Language. 
     * @summary Get aggregated recruitment statistics for the admin dashboard
     * @param {string} adminUserId 
     * @param {string} [from] First day of the period (inclusive); without it the period starts at the first candidate
     * @param {string} [to] Last day of the period (inclusive); without it the period ends today
     * @param {DashboardRegionTypeDto} [regionType] Which region of the candidate the region filter applies to; required together with region
     * @param {string} [region] ISO 3166-2 code of the region (e.g. PL-14), required together with regionType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminDashboardApiInterface
     */
    getAdminDashboard(adminUserId: string, from?: string, to?: string, regionType?: DashboardRegionTypeDto, region?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminDashboardDto>;

}

/**
 * RestAdminDashboardApi - object-oriented interface
 * @export
 * @class RestAdminDashboardApi
 * @extends {BaseAPI}
 */
export class RestAdminDashboardApi extends BaseAPI implements RestAdminDashboardApiInterface {
    /**
     * All statistics describe the cohort of candidates whose account was created in the period (dates in Europe/Warsaw). The optional region filter narrows the cohort to candidates who study (regionType STUDY) or want an internship (regionType INTERNSHIP) in the region, except for the region maps, which always show every region so that the selected one can be highlighted. Labels of areas, skills and dictionaries follow Accept-Language. 
     * @summary Get aggregated recruitment statistics for the admin dashboard
     * @param {string} adminUserId 
     * @param {string} [from] First day of the period (inclusive); without it the period starts at the first candidate
     * @param {string} [to] Last day of the period (inclusive); without it the period ends today
     * @param {DashboardRegionTypeDto} [regionType] Which region of the candidate the region filter applies to; required together with region
     * @param {string} [region] ISO 3166-2 code of the region (e.g. PL-14), required together with regionType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminDashboardApi
     */
    public getAdminDashboard(adminUserId: string, from?: string, to?: string, regionType?: DashboardRegionTypeDto, region?: string, options?: RawAxiosRequestConfig) {
        return RestAdminDashboardApiFp(this.configuration).getAdminDashboard(adminUserId, from, to, regionType, region, options).then((request) => request(this.axios, this.basePath));
    }
}

